import type { IRegDataStagedChange, IRegDataWarning } from "../../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

export function getWarningsForStagedChange(
    change: IRegDataStagedChange,
    comparison: { fields?: { fieldKey: string; matches?: { templateOption: { rawValue: string }; warnings: IRegDataWarning[] }[] }[] } | null
): IRegDataWarning[] {
    if (!change.templateRawValue || !comparison?.fields) return [];
    const card = comparison.fields.find((field) => field.fieldKey === change.fieldKey);
    const match = card?.matches?.find((row) => row.templateOption.rawValue === change.templateRawValue);
    return match?.warnings ?? [];
}
